import React, { useState } from 'react';
import '../styles/ContactPage.css';

const API_URL = 'https://eo8rw5woae.execute-api.us-east-2.amazonaws.com/contact';

const ContactPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setStatus('loading');

    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, message }),
      });
      const data = await res.json();
      if (data.success) {
        setStatus('success');
      } else {
        setError(data.error || 'Something went wrong');
        setStatus('idle');
      }
    } catch {
      setError('Something went wrong. Try again.');
      setStatus('idle');
    }
  };

  if (status === 'success') {
    return (
      <div className="contact-page">
        <div className="container">
          <div className="contact-success">
            <h1>Message sent</h1>
            <p>We'll get back to you soon.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-page">
      <div className="container">
        <div className="contact-content">
          <h1>Get in touch</h1>
          <p className="contact-subtitle">Questions, feedback, enterprise inquiries, or anything else.</p>
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="contact-input"
            />
            <textarea
              placeholder="What's on your mind?"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              className="contact-textarea"
              rows={6}
            />
            {error && <p className="contact-error">{error}</p>}
            <button type="submit" className="primary-button" disabled={status === 'loading'}>
              {status === 'loading' ? 'Sending...' : 'Send message'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
